import { Component, OnInit } from '@angular/core';
import { StudentService } from 'src/app/shared/student.service';
import { NgForm } from '@angular/forms';
import { AngularFirestore } from '@angular/fire/firestore';
import { ProductService } from 'src/app/shared/product.service';
import { Product } from 'src/app/shared/product.model';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-student',
  templateUrl: './student.component.html',
  styleUrls: ['./student.component.css']
})
export class StudentComponent implements OnInit {

  message: string;
  productList: Product[];
  quantity = new Map<string, string>();
  order = new Array<number>();
  min: string;
  today: Date;

  constructor(private service: StudentService, private productService: ProductService, private fireStore: AngularFirestore, private datePipe: DatePipe) { }

  ngOnInit() {
    this.today = new Date(this.datePipe.transform(new Date().toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }), "yyyy-MM-dd HH:mm:ss"));
    this.resetForm();
    this.productService.getAllProducts().subscribe(response => {
      this.productList = response.map(document => {
        return {
          id: document.payload.doc.id,
          ...document.payload.doc.data() as {}    // Attention - Require typescript version >3 to work!!
        } as Product;
      })
      for (let i = 0; i < this.productList.length; i++) {
        this.order[i] = 0;
      }
    });

    if (this.today.getHours() > 8) {
      const tomorrow = new Date(this.today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      this.min = this.datePipe.transform(tomorrow.toLocaleString('en-US'), "yyyy-MM-dd")
    }
    else {
      this.min = this.datePipe.transform(this.today.toLocaleString('en-US'), "yyyy-MM-dd")
    }
  }

  updateOrder(a: any, b: any) {
    this.quantity.set(a.rollNo + "(Rs." + a.fullName + ") Quantity: ", b);
    this.service.formData.total = 0;
    for (let i = 0; i < this.productList.length; i++) {
      this.service.formData.total = this.service.formData.total + this.order[i] * parseInt(this.productList[i].fullName);
    }
  }

  resetForm(form?: NgForm) {
    if (form != null) {
      form.resetForm();
    }
    this.service.formData = {
      id: null,
      fullName: '',
      branchName: '',
      rollNo: '',
      guardianPhoneNo: '',
      paymentType: '',
      comments: '',
      total: 0,
      quantity: [],
      date: new Date(),
      orderFor: ''
    }
  }

  onSubmit(form: NgForm) {
    this.message = '';
    form.value.quantity = [];

    for (let entry of this.quantity.entries()) {
      form.value.quantity.push(entry[0] + entry[1]);
    }

    form.value.total = this.service.formData.total;
    form.value.date = new Date().toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });

    let studentData = Object.assign({}, form.value);
    delete studentData.id;

    if (form.value.id == null) {
      this.fireStore.collection('students').add(studentData);
      this.message = 'Order submitted!';
      alert('Your order has been received. Thank You!');
    } else {
      this.fireStore.doc('students/' + form.value.id).update(studentData);
      this.message = 'Order successfully updated!';
    }

    this.resetForm(form);
  }
}
